// extracted by mini-css-extract-plugin
module.exports = {"headlineHover":"headlineHover___353Pq","disabled":"disabled___3HSat"};